import React from 'react';
import CommunityDetails from '../components/CommunityDetails';

export default function CommunityDetailsPage() {
  return <CommunityDetails />;
}